<template>
  <div class="ops-wrapper">
    <div class="animated fadeIn">
      <div class="ops container-custom">
        <div class="ops__wrapper">
          <div class="ops__header">
            <div class="ops__title" id="traffic">Ops Dashboard</div>
          </div>
          <div class="ops__header-filter">
            <div class="ops__header-filter__item">
              <div class="ops__header-filter__item__button subtitle" :class="activeTable === 1 ? 'active' : ''" @click="() => setActiveTable(1)"> <Therapist />Therapist </div>
              <div class="divider-vertical"></div>
              <div class="ops__header-filter__item__button subtitle" :class="activeTable === 0 ? 'active' : ''" @click="() => setActiveTable(0)"><Therapist /> Region </div>
            </div>
            <div class="ops__header-filter__item">
              <div class="info-btn__item">
                <div class="btn-csv" @click.preventDefault="getDataAsCSV">
                  <i class="icon-cloud-download"></i> CSV
                </div>
              </div>
              <md-field class="select-field">
                <label for="state">State</label>
                <md-select v-model="state" name="state" id="state" md-align-trigger @md-selected="changeState">
                  <md-option :value="state" v-for="(state,index) in states" :key="index">{{state}}</md-option>
                </md-select>
              </md-field>
              <md-field class="select-field multiple" v-if="this.activeTable === 0">
                <label for="region">Select Region</label>
                <md-select v-model="region" name="region" id="region" multiple  @md-selected="changeRegion">
                  <md-option value="all">Select All Region</md-option>
                  <md-option :value="region.id" v-for="(region,index) in regions" :key="index">{{region.name}}</md-option>
                </md-select>
              </md-field>
              <md-field class="select-field">
                <label for="date">Jump to</label>
                <md-select v-model="date" name="date" id="date" md-align-trigger @md-selected="goToPeriod">
                  <md-option :value="date" v-for="(date,index) in dates" :key="index">{{date}}</md-option>
                </md-select>
              </md-field>
              <div class="info-btn__item--time">
                <div class="info-period">
                  <div class="info-period__item" :class="period === 'week' ? 'active' : ''" @click="() => changePeriod('week')">Week</div>
                  <div class="info-period__item" :class="period === 'month' ? 'active' : ''" @click="() => changePeriod('month')">Month</div>
                </div>
              </div>
            </div>
          </div>
          <div class="ops__header-nav">
            <div
                class="ops__header-nav__item"
                slot="header"
                @click="prevPeriod"
                :class="{'disable' : isButtonDisable}">
              <h6  class="ops__header-nav__item__text ops__header-nav__item__text--left"><i class="fa fa-angle-left"></i>Previous {{this.period | capitalizeFirst}}</h6>
            </div>
            <div
                class="ops__header-nav__item"
                slot="header"
                @click="nextPeriod"
                :class="{'disable' : isButtonDisable}">
              <h6  class="ops__header-nav__item__text ops__header-nav__item__text--right">Next {{this.period | capitalizeFirst}}<i class="fa fa-angle-right"></i></h6>
            </div>
          </div>
        </div>
        <div class="full-w">
          <div class="ops__tables">
            <b-row v-if="this.activeTable === 1"  class="therapist-wrapper">
              <b-col cols="12">
                <b-card-group class="table-custom ops__table-custom">
                  <b-card no-body style="max-width: 65%;">
                    <div class="table-custom__header left" slot="header">
                      <h6  class="mb-0 text-center">{{ getDateForPeriod }}</h6>
                    </div>
                    <b-table sticky-header stickyColumn responsive @row-dblclicked="showTherapistActionModal" show-empty small striped
                             class="formatlastrow" thead-tr-class="small"  :tbody-tr-class="totVariant"
                             :busy="current_week_table_busy" :id="current_week_table_id" :items="therapist_summary" :fields="fields_period2">
                      <template #head()="data">
                        <div class="custom-table-header" @click="showFilterColumn($event,data)"> <span>{{data.label}}</span>
                        </div>
                      </template>
                      <template #cell(therapist)="data">
                        <span class="therapist-column" :title="data.value">{{data.value}}</span>
                      </template>
                      <template slot="num_cases" slot-scope="d">
                        <span class="small">{{d.value}}</span>
                      </template>
                      <template slot="dc_soon" slot-scope="d">
                        <span class="small">{{d.value}}</span>
                      </template>
                      <template slot="goal" slot-scope="d">
                        <span class="small">{{d.value}}</span>
                      </template>
                      <template slot="visits" slot-scope="d">
                        <span class="small">{{d.value}}</span>
                      </template>
                      <template slot="points" slot-scope="d">
                        <span class="small">{{d.value}}</span>
                      </template>
                      <template slot="fill_rate" slot-scope="d">
                        <span v-if="d.value > 89" class="small">{{d.value | formatPercent}}</span>
                        <span v-else-if="d.value > 49" class="text-warning small"><strong>{{d.value | formatPercent}}</strong></span>
                        <span v-else class="text-danger"><strong>{{d.value | formatPercent}}</strong></span>
                      </template>
                      <template slot="cxl" slot-scope="d">
                        <span class="small">{{d.value}}</span>
                      </template>
                      <template slot="cxl_rate" slot-scope="d">
                        <span class="small">{{d.value | formatPercent}}</span>
                      </template>
                      <template slot="eval" slot-scope="d">
                        <span class="small">{{d.value}}</span>
                      </template>
                      <template slot="dc" slot-scope="d">
                        <span class="small">{{d.value}}</span>
                      </template>
                      <template slot="freq" slot-scope="d">
                        <span v-if="d.value > 1.9" class="small text-success">{{d.value | formatAccurateNumber}}</span>
                        <span v-else-if="d.value > 1.1" class="text-warning small"><strong>{{d.value | formatAccurateNumber}}</strong></span>
                        <span v-else class="text-danger"><strong>{{d.value | formatAccurateNumber}}</strong></span>
                      </template>
                      <template slot="empty" slot-scope="scope">
                        <h4>No data available</h4>
                      </template>
                      <template slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </template>
                    </b-table>
                    <div class="modal-columns">
                      <div class="column-item" :class="{'active': isActiveTherapist(0,item), 'current': isCurrent(item)}" v-for="(item, i) in therapistFieldsForPopup" @click="setColumnTherapist(item)" :key="i">{{Object.values(item)[0]}}</div>
                    </div>
                  </b-card>
                  <b-card class="table-wrapper-avg" no-body style="max-width: 35%;">
                    <div class="table-custom__header right" slot="header">
                      <h6 slot="header" class="mb-0 text-center">6 Week Average</h6>
                    </div>

                    <div class="regions custom-scroll" v-if="showRegion" v-click-outside="regionOutsideHandler">
                      <div class="regions__item" v-for="(item,index) in regions" :key="index">
                        <label class="checkbox-wrapper">
                          <span>{{item.name}}</span>
                          <input type="checkbox" :value="item.id" @input="changeRegionTherapist(item.id)" >
                          <span class="checkmark" :class="{active: region.some(i => i === item.id)}"></span>
                        </label>
                      </div>
                      <div class="regions__item">
                        <label class="checkbox-wrapper">
                          <span>Select all</span>
                          <input type="checkbox" value="all" @input="changeRegionTherapist('all')">
                          <span class="checkmark"></span>
                        </label>
                      </div>
                    </div>

                    <b-table sticky-header stickyColumn responsive show-empty small striped class="formatlastrow"
                             thead-tr-class="small height" :tbody-tr-class="totVariant"
                             :busy="current_week_table_busy" :id="next_week_table_id" :items="therapist_summary" :fields="fields_period">
                      <template #head()="data">
                        <div class="custom-table-header" @click="showFilterColumn($event,data)">{{data.label}}
                        </div>
                      </template>
                      <template #head(avg_fav_region)="data">
                        <div class="custom-table-header custom-table-header-region">{{data.label}} <span class="custom-table-header__icon" @click="showRegion = !showRegion"><Therapist /></span>
                        </div>
                      </template>
                      <template slot="goal" slot-scope="d">
                        <span class="small">{{d.value}}</span>
                      </template>
                      <template #cell(avg_fav_region)="d">
                        <span class="small" :title="d.value">{{d.value}}</span>
                      </template>
                      <template slot="visits" slot-scope="d">
                        <span class="small">{{d.value}}</span>
                      </template>
                      <template slot="points" slot-scope="d">
                        <span class="small">{{d.value}}</span>
                      </template>
                      <template slot="fill_rate" slot-scope="d">
                        <span v-if="d.value > 89" class="small">{{d.value | formatPercent}}</span>
                        <span v-else-if="d.value > 49" class="text-warning small"><strong>{{d.value | formatPercent}}</strong></span>
                        <span v-else class="text-danger"><strong>{{d.value | formatPercent}}</strong></span>
                      </template>
                      <template slot="cxl" slot-scope="d">
                        <span class="small">{{d.value}}</span>
                      </template>
                      <template slot="cxl_rate" slot-scope="d">
                        <span class="small">{{d.value | formatPercent}}</span>
                      </template>
                      <template slot="eval" slot-scope="d">
                        <span class="small">{{d.value}}</span>
                      </template>
                      <template slot="dc" slot-scope="d">
                        <span class="small">{{d.value}}</span>
                      </template>
                      <template slot="empty" slot-scope="scope">
                        <h4>No data available</h4>
                      </template>
                      <template slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </template>
                    </b-table>
                    <div class="modal-columns">
                      <div class="column-item" :class="{'active': isActiveTherapist(1,item), 'current': isCurrent(item)}" v-for="(item, i) in fields_period_all" @click="setColumnTherapistAvg(item)" :key="i">{{Object.values(item)[0]}}</div>
                    </div>
                  </b-card>
                </b-card-group>
              </b-col>
            </b-row>
            <b-row v-else>
              <b-col cols="12">
                <b-card-group class="table-custom ops__table-custom">
                  <b-card no-body  style="min-width: 65%">
                    <div class="table-wrapper" v-for="(item, c) in region_summary" :key="c">
                      <h6  class="header--region">{{item.region}}</h6>
                      <h6  class="mb-0 header--date">{{getDateForPeriod}}</h6>
                      <b-table responsive show-empty small striped class="formatlastrow"
                               thead-tr-class="text-nowrap small" :tbody-tr-class="totVariant"
                               :busy="region_summary_table_busy" :id="region_summary_table_id" :items="item.therapist" :fields="fields_region_summary">
                        <template #head()="data">
                          <div class="custom-table-header" @click="showFilterColumn($event,data)">{{data.label}}
                          </div>
                        </template>
                        <template #cell(therapist)="data">
                          {{ data.value ? data.value : 'Total' }}
                        </template>
                        <template slot="region" slot-scope="d">
                          <span class="small">{{d.value}}</span>
                        </template>
                        <template slot="num_cases" slot-scope="d">
                          <span class="small">{{d.value}}</span>
                        </template>
                        <template slot="visits" slot-scope="d">
                          <span class="small">{{d.value}}</span>
                        </template>
                        <template slot="cxl" slot-scope="d">
                          <span class="small">{{d.value}}</span>
                        </template>
                        <template slot="cxl_rate" slot-scope="d">
                          <span class="small">{{d.value | formatPercent}}</span>
                        </template>
                        <template slot="eval" slot-scope="d">
                          <span class="small">{{d.value}}</span>
                        </template>
                        <template slot="dc" slot-scope="d">
                          <span v-if="d.value > d.item.eval" class="text-danger">{{d.value}}</span>
                          <span v-else class="small">{{d.value}}</span>
                        </template>
                        <template slot="empty" slot-scope="scope">
                          <h4>No data available</h4>
                        </template>
                        <template slot="table-busy" class="text-center text-danger my-2">
                          <b-spinner class="align-middle"></b-spinner>
                          <strong>Loading...</strong>
                        </template>
                      </b-table>
                      <div class="modal-columns">
                        <div class="column-item" :class="{'active': isActive(0,item), 'current': isCurrent(item)}" v-for="item in regiontFieldsForPopup"  @click="setColumn(item)">{{Object.values(item)[0]}}</div>
                      </div>
                    </div>
                  </b-card>
                  <b-card no-body>
                    <div class="table-wrapper table-wrapper-avg" v-for="(item, r) in region_summary" :key="r">
                      <h6  class="header--region"></h6>
                      <h6 class="mb-0 text-center header--date">6 Week Average</h6>
                      <b-table responsive show-empty small striped class="formatlastrow"
                               thead-tr-class="text-nowrap small" :tbody-tr-class="totVariant"
                               :busy="region_summary_table_busy" :id="region_summary_next_table_id" :items="item.therapist" :fields="fields_region_summary_next">
                        <template #head()="data">
                          <div class="custom-table-header" @click="showFilterColumn($event,data)"><span>{{data.label}}</span>
                          </div>
                        </template>
                        <template #cell(therapist)="data">
                          <span class="therapist-column" :title="data.value">{{data.value}}</span>
                        </template>
                        <template slot="visits" slot-scope="d">
                          <span class="small">{{d.value || 0}}</span>
                        </template>
                        <template slot="cxl" slot-scope="d">
                          <span class="small">{{d.value || 0}}</span>
                        </template>
                        <template slot="cxl_rate" slot-scope="d">
                          <span class="small">{{d.value | formatPercent}}</span>
                        </template>
                        <template slot="eval" slot-scope="d">
                          <span class="small">{{d.value || 0}}</span>
                        </template>
                        <template slot="dc" slot-scope="d">
                          <span class="small">{{d.value || 0}}</span>
                        </template>
                        <template slot="empty" slot-scope="scope">
                          <h4>No data available</h4>
                        </template>
                        <template slot="table-busy" class="text-center text-danger my-2">
                          <b-spinner class="align-middle"></b-spinner>
                          <strong>Loading...</strong>
                        </template>
                      </b-table>
                      <div class="modal-columns">
                        <div class="column-item" :class="{'active': isActive(1,item), 'current': isCurrent(item)}" v-for="item in fields_region_summary_next_all" @click="setColumnAvg(item)">{{Object.values(item)[0]}}</div>
                      </div>
                    </div>
                  </b-card>
                </b-card-group>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
      <b-modal size="xl" scrollable :id="therapist_action_modal_id"
               :title="therapist_action_modal_title" ok-only ok-title="Close">
        <template slot="modal-title">
          <b-row>
            <b-col class="avatar mr-3" cols="2">
              <div class="avatar">
                <img src="img/avatars/1.jpg" class="img-avatar" alt="">
                <span class="avatar-status bg-success"></span>
              </div>
            </b-col>
            <b-col cols="9">
              {{therapist_action_modal_title}}
            </b-col>
            <b-col cols="1">
            </b-col>
          </b-row>
        </template>
        <b-row> </b-row>
        <b-card no-body>
          <h6 slot="header" class="mb-0">All Open Cases for {{therapist_action_modal_title}} <span style="float:right;"><span style="background-color: white; padding: 5px;">Active</span> <span style="background-color: #fff2d1; padding: 5px; margin-left: 10px;">On Hold</span></span></h6>
          <b-table responsive show-empty small thead-tr-class="text-nowrap small"
                   :tbody-tr-class="bgVariant"
                   :busy="therapist_action_modal_case_table_busy"
                   :id="therapist_action_modal_case_table_id" :items="therapist_action_modal_case_table_data"
                   :fields="therapist_action_modal_case_table_fields">

            <template #cell(id)="data">
              <a :href="'https://crmplus.zoho.com/farr10/index.do/cxapp/crm/petehealth/tab/CustomModule13/' +('4888494000000000000'.slice(0, -String(data.value).length) + data.value)" target="_blank">{{ data.value }}</a>
            </template>
            <template slot="empty" slot-scope="scope">
              <h4>No data available</h4>
            </template>
            <template slot="table-busy" class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </template>
          </b-table>
        </b-card>
      </b-modal>
    </div>

    <div class="custom-footer-total" :class="activeTable === 0 ? 'region' : ''">
      <div class="ops container container-custom">
        <b-row v-if="this.activeTable === 1">
          <b-col cols="12">
            <b-card-group class="table-custom ops__table-custom">
              <b-card no-body style="max-width: 65%;">
                <b-table responsive @row-dblclicked="showTherapistActionModal" show-empty small borderless :outlined="false"
                         class="formatlastrow summary-table " thead-tr-class="small"  :tbody-tr-class="totVariant"
                         :busy="current_week_table_busy"
                         :id="current_week_table_id"
                         :items="[therapist_summary.slice(-1).length > 0 ? therapist_summary.slice(-1)[0] : []]"
                         :fields="fields_period2">
                  <template #head(therapist)="data">
                    <span>Selection Total</span>
                  </template>
                  <template #cell(therapist)="data">
                    <span class="text-info">{{data.value.replace('Total','')}}</span>
                  </template>
                  <template slot="therapist" slot-scope="d">
                    <span class="small 123" style="max-width: 160px; display: block; text-overflow: ellipsis; overflow: hidden"> 123</span>
                  </template>
                  <template slot="num_cases" slot-scope="d">
                    <span class="small">{{d.value}}</span>
                  </template>
                  <template slot="dc_soon" slot-scope="d">
                    <span class="small">{{d.value}}</span>
                  </template>
                  <template slot="goal" slot-scope="d">
                    <span class="small">{{d.value}}</span>
                  </template>
                  <template slot="visits" slot-scope="d">
                    <span class="small">{{d.value}}</span>
                  </template>
                  <template slot="points" slot-scope="d">
                    <span class="small">{{d.value}}</span>
                  </template>
                  <template slot="fill_rate" slot-scope="d">
                    <span v-if="d.value > 89" class="small">{{d.value | formatPercent}}</span>
                    <span v-else-if="d.value > 49" class="text-warning small"><strong>{{d.value | formatPercent}}</strong></span>
                    <span v-else class="text-danger"><strong>{{d.value | formatPercent}}</strong></span>
                  </template>
                  <template slot="cxl" slot-scope="d">
                    <span class="small">{{d.value}}</span>
                  </template>
                  <template slot="cxl_rate" slot-scope="d">
                    <span class="small">{{d.value | formatPercent}}</span>
                  </template>
                  <template slot="eval" slot-scope="d">
                    <span class="small">{{d.value}}</span>
                  </template>
                  <template slot="dc" slot-scope="d">
                    <span class="small">{{d.value}}</span>
                  </template>
                  <template slot="freq" slot-scope="d">
                    <span v-if="d.value > 1.9" class="small text-success">{{d.value | formatAccurateNumber}}</span>
                    <span v-else-if="d.value > 1.1" class="text-warning small"><strong>{{d.value | formatAccurateNumber}}</strong></span>
                    <span v-else class="text-danger"><strong>{{d.value | formatAccurateNumber}}</strong></span>
                  </template>
                  <template slot="empty" slot-scope="scope">
                    <h4>No data available</h4>
                  </template>
                  <template slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </template>
                </b-table>
              </b-card>
              <b-card no-body style="max-width: 35%;">
                <b-table responsive show-empty small borderless class="formatlastrow table-borderless next-summary-table"
                         thead-tr-class="text-nowrap small" :tbody-tr-class="totVariant"
                         :busy="current_week_table_busy"
                         :id="next_week_table_id"
                         :items="[therapist_summary.slice(-1).length > 0 ? therapist_summary.slice(-1)[0] : []]"
                         :fields="fields_period">
                  <template slot="goal" slot-scope="d">
                    <span class="small">{{d.value}}</span>
                  </template>
                  <template slot="visits" slot-scope="d">
                    <span class="small">{{d.value}}</span>
                  </template>
                  <template slot="points" slot-scope="d">
                    <span class="small">{{d.value}}</span>
                  </template>
                  <template slot="fill_rate" slot-scope="d">
                    <span v-if="d.value > 89" class="small">{{d.value | formatPercent}}</span>
                    <span v-else-if="d.value > 49" class="text-warning small"><strong>{{d.value | formatPercent}}</strong></span>
                    <span v-else class="text-danger"><strong>{{d.value | formatPercent}}</strong></span>
                  </template>
                  <template slot="cxl" slot-scope="d">
                    <span class="small">{{d.value}}</span>
                  </template>
                  <template slot="cxl_rate" slot-scope="d">
                    <span class="small">{{d.value | formatPercent}}</span>
                  </template>
                  <template slot="eval" slot-scope="d">
                    <span class="small">{{d.value}}</span>
                  </template>
                  <template slot="dc" slot-scope="d">
                    <span class="small">{{d.value}}</span>
                  </template>
                  <template slot="empty" slot-scope="scope">
                    <h4>No data available</h4>
                  </template>
                  <template slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </template>
                </b-table>
              </b-card>
            </b-card-group>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col cols="12" v-if="region_summary_footer.length > 0">
            <b-card-group class="table-custom ops__table-custom">
              <b-card no-body  style="min-width: 65%">
                <b-table responsive show-empty small borderless :outlined="false" striped class="formatlastrow summary-table"
                         thead-tr-class="text-nowrap small" :tbody-tr-class="totVariant"
                         :busy="region_summary_table_busy"
                         :id="region_summary_table_id"
                         :items="region_summary_footer"
                         :fields="fields_region_summary">
                  <template slot="region" slot-scope="d">
                    <span class="small">{{d.value}}</span>
                  </template>
                  <template slot="num_cases" slot-scope="d">
                    <span class="small">{{d.value}}</span>
                  </template>
                  <template slot="visits" slot-scope="d">
                    <span class="small">{{d.value}}</span>
                  </template>
                  <template slot="cxl" slot-scope="d">
                    <span class="small">{{d.value}}</span>
                  </template>
                  <template slot="cxl_rate" slot-scope="d">
                    <span class="small">{{d.value | formatPercent}}</span>
                  </template>
                  <template slot="eval" slot-scope="d">
                    <span class="small">{{d.value}}</span>
                  </template>
                  <template slot="dc" slot-scope="d">
                    <span v-if="d.value > d.item.eval" class="text-danger">{{d.value}}</span>
                    <span v-else class="small">{{d.value}}</span>
                  </template>
                  <template slot="empty" slot-scope="scope">
                    <h4>No data available</h4>
                  </template>
                  <template slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </template>
                </b-table>
              </b-card>
              <b-card no-body>
                <b-table responsive show-empty small striped class="formatlastrow next-summary-table"
                         thead-tr-class="text-nowrap small" :tbody-tr-class="totVariant"
                         :busy="region_summary_table_busy"
                         :id="region_summary_next_table_id"
                         :items="region_summary_footer"
                         :fields="fields_region_summary_next">
                  <template slot="visits" slot-scope="d">
                    <span class="small">{{d.value || 0}}</span>
                  </template>
                  <template slot="cxl" slot-scope="d">
                    <span class="small">{{d.value || 0}}</span>
                  </template>
                  <template slot="cxl_rate" slot-scope="d">
                    <span class="small">{{d.value | formatPercent}}</span>
                  </template>
                  <template slot="eval" slot-scope="d">
                    <span class="small">{{d.value || 0}}</span>
                  </template>
                  <template slot="dc" slot-scope="d">
                    <span class="small">{{d.value || 0}}</span>
                  </template>
                  <template slot="empty" slot-scope="scope">
                    <h4>No data available</h4>
                  </template>
                  <template slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </template>
                </b-table>
              </b-card>
            </b-card-group>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>

  import dayjs from 'dayjs';
  import { isNumber } from 'util';
  import Therapist from './icons/Therapist.vue';
  import VuePerfectScrollbar from 'vue-perfect-scrollbar';
  import vClickOutside from 'v-click-outside';

  var qs = require('qs');
  export default {
    name: 'OpsDashboard',
    components: {
      Therapist,
      VuePerfectScrollbar,
    },
    directives: {
      clickOutside: vClickOutside.directive
    },
    async mounted() {
      this.getColNames(0);
      this.getColNames(1);
      const date0 = this.getDateForData(0);
      await this.getAllData(date0);
      this.setCurrentTime();
      this.getRegions();
      this.getStates();
      this.getDatesForSelect();
    },
    computed: {
      therapist_summary_cards: function() {
        return this.therapist_summary.slice(0,-1).sort(function(a,b) {return (b.goal - (b.points + b.sched)) - (a.goal - (a.points + a.sched))})
      },
      getDateForPeriod: function () {
        return this.getDateForHdr()
      },
      therapistFieldsForPopup() {
          return this.fields_period2_all.filter((e) => Object.keys(e)[0] !== 'therapist');
      },
      regiontFieldsForPopup() {
          return this.fields_region_summary_all.filter((e) => Object.keys(e)[0] !== 'therapist');
      },
      isButtonDisable() {
          return (this.activeTable === 1 && this.current_week_table_busy) || (this.activeTable === 0 && this.region_summary_table_busy);
      }
    },
    filters: {
      formatPercent: function (v) {
        if (isNumber(v)) {
          return Math.round(v) + '%'
        }
      },
      formatAccurateNumber: function (v) {
        if (isNumber(v)) {
          return v.toFixed(2) + ''
        }
      },
      capitalizeFirst: function (v) {
        if (typeof v == 'string') {
          return v.charAt(0).toUpperCase() + v.substring(1).toLowerCase();
        }
      },
      formatPhone: function (v) {
        var cleaned = ('' + v).replace(/\D/g, '')
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
        if (match) {
          var intlCode = (match[1] ? '+1 ' : '')
          return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
        }
        return null
      },
    },
    data: function () {
      return {
        todaysfulldate: dayjs().format("LLLL"),
        dateForData: new Date(),
        countPeriod: 0,
        csv: null,
        period: 'week',
        activeTable: 1,
        therapist_summary: [],
        period_prefix_table_id: 'PeriodPrefix',
        current_week_table_id: 'CurrentWeekTherapistSummary',
        current_week_table_busy: true,
        next_week_table_id: 'NextWeekTherapistSummary',

        region_summary: [],
        region_summary_next: [],
        region_summary_table_id: 'CurrentWeekRegionSummary',
        region_summary_table_busy: true,
        region_summary_next_table_id: 'NextWeekRegionSummary',

        therapist_action_modal_id: 'TherapistActionModal',
        therapist_action_modal_title: '',

        avail_days: 6,
        avail_data: [],

        therapist_action_modal_case_table_id: 'TherapistActionModalTable',
        therapist_action_modal_case_table_data: [],
        therapist_action_modal_case_table_fields: [
          {key:'id', label: '',}, 'patient', 'patient_phone',
          'last_visit', 'to_ops', 'to_thearapist', 'insurance', 'region',
          'patient_email'
        ],
        therapist_action_modal_case_table_busy: true,

        therapist_obj: [],

        fields_period: [],
        fields_period2: [],

        fields_period_all: [],
        fields_period2_all: [],

        fields_region_summary: [],
        fields_region_summary_next: [],

        fields_region_summary_all: [],
        fields_region_summary_next_all: [],

        fields_period2_main_key: [
            'therapist',
            'needs_more',
            'active',
            'on_hold',
            'visits',
            'freq',
            'goal',
            // 'points',
            'fill_rate',
            'cxl_rate',
            'eval',
            'dc'
        ],
        fields_period_main_key: [
            'avg_active',
            'avg_visits',
            'replace',
            'taking_patient',
            'avg_fav_region',
        ],
        fields_region_summary_main_key: [
            'therapist',
            'active',
            'freq',
            'visits',
            'points',
            'cxl',
            'cxl_rate'
        ],
        fields_region_summary_next_main_key: [
            'avg_visits',
            'avg_active',
            'avg_pct_mc',
            'avg_freq',
            'avg_points',
        ],
        region: [],
        regions: [],
        state: '',
        states: [],
        date: '',
        dates: [],
        showRegion: false,
        region_summary_footer: [],
        current_summary_item: undefined,
        current_date: new Date(),
      }
    },
    watch: {
      period: async function () {
        this.countPeriod = 0;
        this.getDatesForSelect();
      }
    },
    methods: {
      isActive(type,item) {
          if (type) {
              return this.fields_region_summary_next.some((e) => e && Object.keys(e)[0] === Object.keys(item)[0]);
          } else {
              return this.fields_region_summary.some((e) => e && Object.keys(e)[0] === Object.keys(item)[0]);
          }
      },
      isCurrent(item) {
          return this.current_summary_item && Object.keys(this.current_summary_item)[0] === Object.keys(item)[0]
      },
      setColumn(item) {
          const index = this.fields_region_summary.findIndex((item) => Object.keys(this.current_summary_item)[0] === Object.keys(item)[0]);
          if (index > -1 && !this.isActive(0,item)) {
              this.fields_region_summary.splice(index, 1, item);
              this.current_summary_item = item;
          }
      },
      setColumnAvg(item) {
          const index = this.fields_region_summary_next.findIndex((item) => Object.keys(this.current_summary_item)[0] === Object.keys(item)[0]);
          if (index > -1 && !this.isActive(1,item)) {
              this.fields_region_summary_next.splice(index, 1, item);
              this.current_summary_item = item;
          }
      },
      isActiveTherapist(type,item) {
          if (type) {
              return this.fields_period.some((e) => e && Object.keys(e)[0] === Object.keys(item)[0]);
          } else {
              return this.fields_period2.some((e) => e && Object.keys(e)[0] === Object.keys(item)[0]);
          }
      },
      setColumnTherapist(item) {
          const index = this.fields_period2.findIndex((item) => item && Object.keys(this.current_summary_item)[0] === Object.keys(item)[0]);
          if (index > -1 && !this.isActiveTherapist(0,item)) {
              this.fields_period2.splice(index, 1, item);
              this.current_summary_item = item;
          }
      },
      setColumnTherapistAvg(item) {
          const index = this.fields_period.findIndex((item) => item && Object.keys(this.current_summary_item)[0] === Object.keys(item)[0]);
          if (index > -1 && !this.isActiveTherapist(1,item)) {
              this.fields_period.splice(index, 1, item);
              this.current_summary_item = item;
          }
      },

      closeModalColumns() {
          const elems = document.getElementsByClassName('modal-columns');
          [].forEach.call(elems, function(el) {
              el.classList.remove("active");
          });
      },
      showFilterColumn(e, data) {
          this.current_summary_item = {
              [data.field.key] : data.field.value
          };
          let elements = document.getElementsByClassName('modal-columns');
          let containClassActive = false;
          for (var i = 0; i < elements.length; i++) {
              if (elements[i].classList.contains('active')) {
                  containClassActive = true;
                  break;
              }
          }
          if (containClassActive) {
              this.closeModalColumns()
          } else {
              e.target.closest('.formatlastrow').nextElementSibling.classList.add("active");
          }
      },
      getDatesForSelect() {
        this.dates = [];
        for (let i = 0; i < 6; i++) {
          this.dates.push(this.getDateForHdr2(i));
        }
      },
      async getRegions() {
        const params = [];
        const endpoint = "/regions";
        params.agg = 'region';
        try {
          const r = await this.$newpetehealthapi.get(endpoint, {
            params: params,
            paramsSerializer: params => {
              return qs.stringify(params)
            }
          });
          this.regions = r.data;
        } catch (e) {
          console.log(e)
        }
      },
      async getStates() {
        const params = [];
        const endpoint = "/states";
        try {
          const r = await this.$newpetehealthapi.get(endpoint, {
            params: params,
            paramsSerializer: params => {
              return qs.stringify(params)
            }
          });
          this.states = r.data.map((e) => e.state).filter((e) => e);
        } catch (e) {
          console.log(e)
        }
      },
      async getColNames(param) {
          const params = [];
          const endpoint = "/opsdata/colmap";
          params.agg = param ? 'therapist' : 'region';
          try {
              const r = await this.$newpetehealthapi.get(endpoint, {
                  params: params,
                  paramsSerializer: params => {
                      return qs.stringify(params)
                  }
              });
              const allFields = this.getTableAllFields(r.data[0]);
              if (param) {
                  this.fields_period2_all = this.getTableFields(r.data[0]);
                  this.fields_period_all = this.getTableAvgFields(r.data[0]);

                  this.fields_period2 = this.fields_period2_main_key.map((item) => {
                      return allFields.filter((e) => Object.keys(e)[0] === item)[0]
                  });
                  this.fields_period = this.fields_period_main_key.map((item) => {
                      return allFields.filter((e) => Object.keys(e)[0] === item)[0]
                  });
              } else {
                  this.fields_region_summary_all = this.getTableFields(r.data[0]);
                  this.fields_region_summary_next_all = this.getTableAvgFields(r.data[0]);

                  this.fields_region_summary = this.fields_region_summary_main_key.map((item) => {
                      return allFields.filter((e) => Object.keys(e)[0] === item)[0]
                  });
                  this.fields_region_summary_next = this.fields_region_summary_next_main_key.map((item) => {
                      return allFields.filter((e) => Object.keys(e)[0] === item)[0]
                  });
              }

          } catch (e) {
              console.log(e)
          }
      },
      getTableFields(fields) {
          return Object.keys(fields)
              .map((key) => [key, fields[key]])
              .filter((item) => !item[0].startsWith("avg"))
              .map((item) => {
                  return {[item[0]]:item[1]}
              });
      },
      getTableAvgFields(fields) {
          return Object.keys(fields)
              .map((key) => [key, fields[key]])
              .filter((item) => item[0].startsWith("avg"))
              .map((item) => {
                  return {[item[0]]:item[1]}
              });
      },
      getTableAllFields(fields) {
          return Object.keys(fields)
              .map((key) => [key, fields[key]])
              .map((item) => {
                  return {[item[0]]:item[1]}
              });
      },
      changeState() {
        this.getAllData();
      },
      changeRegion(e) {
        if (e === 'all') {
          this.region.length = 0;
        }
        this.getAllData();
      },
      regionOutsideHandler() {
        this.showRegion = false;
      },
      changeRegionTherapist(e) {
        if (e === 'all') {
          this.region.length = 0;
        } else {
          const index = this.region.indexOf(e);
          if (index > -1) {
            this.region.splice(index, 1);
          } else {
            this.region.push(e);
          }
        }
        this.getTherapistSummary().then(res => {
            this.therapist_summary = res;
        });
      },
      getAllData(date) {
        this.current_date = date;
        this.getTherapistSummary(date).then(res => {
          this.therapist_summary = res;
        });

        this.getRegionSummary(date).then(res => {
          this.region_summary = res;
        });

      },

      getDate(period) {
        const d = new Date(this.current_date);
        if (this.period === 'week') {
          const curDay = new Date(d.getFullYear(), d.getMonth(), d.getDate());
          return dayjs(curDay).add((this.countPeriod + period) * 7 - (d.getDay() + 6) % 7, 'days').toDate();
        } else {
          const curMon = new Date(d.getFullYear(), d.getMonth());
          return dayjs(curMon).add((this.countPeriod + period), 'months').toDate();
        }
      },

      getNextDate() {
        if (this.period === 'week') {
          return dayjs(this.current_date).add(1, 'week').toDate();
        } else {
          return dayjs(this.current_date).add(1, 'months').startOf('month').toDate();
        }
      },
      getPrevDate() {
        if (this.period === 'week') {
          return dayjs(this.current_date).subtract(1, 'week').toDate();
        } else {
          return dayjs(this.current_date).subtract(1, 'months').startOf('month').toDate();
        }
      },
      //for select date
      getDateForSelect(i) {
        if (this.period === 'week') {
          return dayjs(this.current_date).subtract(i, 'week').toDate();
        } else {
          return dayjs(this.current_date).subtract(i, 'months').startOf('month').toDate();
        }
      },
      //for select date
      getDateForHdr2(i) {
        const fmtStr = (this.period === 'week') ? 'DD  MMM YYYY' :'MMM YYYY';
        return dayjs(this.getDateForSelect(i)).format(fmtStr);
      },


      getDateForHdr() {
        const fmtStr = (this.period === 'week') ? 'DD  MMM YYYY' :'MMM YYYY';
        return dayjs(this.current_date).format(fmtStr);
      },

      getDateForData(period) {
        return dayjs(this.getDate(period)).format('YYYY-MM-DD')
      },

      getDateForNewData(period) {
        if (period) {
          return dayjs(this.getNextDate(period)).format('YYYY-MM-DD')
        } else {
          return dayjs(this.getPrevDate(period)).format('YYYY-MM-DD')
        }

      },
      setActiveTable(table) {
        this.activeTable = table;
        this.region = [];
        this.state = '';
      },

      dateHelper(number) {
        if (number < 10) return '0'+number;
        return number;
      },

      goToPeriod(period) {
        if (this.period === 'month') {
          const k = new Date(new Date(period).getFullYear(), new Date(period).getMonth(), 1);
          const d = new Date(k)
          const curr_date = d.getDate();
          const curr_month = d.getMonth() + 1;
          const curr_year = d.getFullYear();
          period = curr_year + "-" + this.dateHelper(curr_month) + "-" + this.dateHelper(curr_date);
        } else {
          period = dayjs(period).format('YYYY-MM-DD');
        }
        this.current_date = period;
        this.getAllData(this.current_date)
      },

      nextPeriod() {
        const date = this.getDateForNewData(1);
        this.getAllData(date);
      },

      prevPeriod() {
        const date = this.getDateForNewData(0);
        this.getAllData(date);
      },

      changePeriod(data) {
        this.period = data;
        if (this.period === 'week') {
          this.current_date = dayjs(this.current_date).weekday(0).format('YYYY-MM-DD');
        } else {
          this.current_date = dayjs(this.current_date).startOf('month').format('YYYY-MM-DD');
        }
        this.date = dayjs(this.current_date).format((this.period === 'week') ? 'DD  MMM YYYY' :'MMM YYYY');
        this.getAllData(this.current_date);
      },

      async getTherapistSummary(date) {
        this.current_week_table_busy = true;
        const params = [];
        const endpoint = "/opsdata";

        if (this.csv) params.csv = true;
        if (date) params.since = date;
        params.period = this.period;
        params.agg = 'therapist';

        if (this.state) params.state = this.state;
        if (this.region.length > 0) {
          params.region = this.region.join();
        }
        try {
          const r = await this.$newpetehealthapi.get(endpoint, {
            params: params,
            paramsSerializer: params => {
              return qs.stringify(params)
            }
          });

          return r.data.filter(t => t.therapist_id == null || t.ph_status == 'Active' || t.visits > 0);
        } catch (e) {
          console.log(e)
        } finally {
          this.current_week_table_busy = false;
        }
      },

      async getRegionSummary(date) {
        this.region_summary_table_busy = true;
        const params = [];
        const endpoint = "/opsdata";

        if (this.csv) params.csv=true;
        if (date) params.since = date;
        params.period = this.period;
        params.agg = 'region';

        if (this.state) params.state = this.state;
        if (this.region.length > 0) {
          params.region = this.region.join();
        }

        try {
          const r = await this.$newpetehealthapi.get(endpoint, {
            params: params,
            paramsSerializer: params => {
              return qs.stringify(params)
            }
          });
          r.data = r.data.forEach(d => d.therapist = d.therapist.filter(t => t.therapist_id == null || t.ph_status == 'Active' || t.visits > 0));

          this.region_summary_footer.length = 0;
          this.region_summary_footer.push(r.data[r.data.length-1].therapist[0]);

          return r.data.slice(0,-1);
        } catch (e) {
          console.log(e);
        } finally {
          this.region_summary_table_busy = false;
        }
      },

      setCurrentTime() {
        this.todaysfulldate = dayjs().format("LLLL")
      },

      showTherapistActionModal(item, idx, e) {
        console.log(item)
        this.therapist_action_modal_title = item.hasOwnProperty('therapist') ? item.therapist : (item.srcElement.classList.contains('stretched-link') ? item.srcElement.outerText : NULL)
        this.getTherapistActionModalCaseData(item.therapist_id || this.therapist_action_modal_title)
        this.getTherapistObj(this.therapist_action_modal_title)
        this.$bvModal.show(this.therapist_action_modal_id)
      },

      getTherapistActionModalCaseData(therapist) {
        this.therapist_action_modal_case_table_busy = true;
        var endpoint = "/cases"
        var params = {};

        if (typeof therapist == 'number') {
          params.therapist_id = therapist
        } else {
          tsplit = therapist.split(' ')
          params.therapist = `${tsplit[1]}, ${tsplit[0]}`
        }
        params.open = 'only'
        params.case_type='pt'

        this.$newpetehealthapi.get(endpoint, {
          params: params,
          paramsSerializer: params => qs.stringify(params)
        }).then( (r) => {
          this.therapist_action_modal_case_table_data = r.data.sort((a,b) => (a.patient > b.patient) ? 1 : ((b.patient > a.patient) ? -1 : 0));
          this.therapist_action_modal_case_table_busy = false;
        })
      },

      getTherapistObj(therapist) {
        var endpoint = "/therapists"
        var params = [];

        params.active = true

        //console.log(params)
        this.$newpetehealthapi.get(endpoint, {
          params: params,
          paramsSerializer: params => {
            return qs.stringify(params)
          }
        }).then( (r) => {
          r.data.forEach( (t, i) => {
            if (t.hasOwnProperty('emr_key') && t.emr_key == therapist) {
              this.therapist_obj = t;
              console.log(this.therapist_obj)
            }
          })
        })
      },

      updateTherapist(e) {
        e.preventDefault()
        let initiator = e.srcElement
        let $this = this
        initiator.disabled="true"
        initiator.innerHTML = "Saving..."

        var target = e.srcElement.dataset.target
        var form = document.getElementById(target)
        var therapist_id = this.therapist_obj.id
        this.$newpetehealthapi.post("/therapists/"+therapist_id, {
          ft_pt: this.therapist_obj.ft_pt,
          weekly_goal: this.therapist_obj.this_weeks_goal,
          monthly_goal: this.therapist_obj.target_visits_per_month,
          pt_pta: this.therapist_obj.pt_pta,
        }).then( function (r) {
          //console.log(r)
          initiator.innerHTML = "Save"
          initiator.disabled=false
          $this.$root.$emit('bv::toggle::collapse', 'therapistprofile')
          return true;
        })
      },
      getDataAsCSV() {
        var params = []
        params.csv = true
        params.since = this.getDateForData(1);
        params.period = this.period;

        var endpoint = "/opsdata"
        var filename = "PH_OpsSummary_"+dayjs(params.since).format("YYYYMMDD")+".csv"

        this.$newpetehealthapi.get(endpoint, {
          params: params,
          paramsSerializer: params => {
            return qs.stringify(params)
          }
        }).then( (r) => {
          //console.log(this.therapist_summary)
          const url = window.URL.createObjectURL(new Blob([r.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          link.parentNode.removeChild(link)
        })
      },
      bgVariant: function(c, type) {
        if (c == undefined) return
        var classStr = "small text-nowrap" // Default classes
        if (c.status == 'On Hold')
          classStr +=  ' text-dark bg-on-hold';
        // else if ((c.scheduled < 2 && c.last_visit && (c.visits + c.scheduled) < c.total_forecast_visits) || (c.scheduled == 0))
        //   classStr += ' text-dark bg-warning';
        else if ((c.scheduled < 2 && c.last_visit && (c.visits + c.scheduled) < c.total_forecast_visits) || (c.scheduled == 0))
          classStr += ' text-dark bg-white';
        return classStr;
      },
      totVariant: function(c, type) {
        if (c == undefined) return
        var classStr = "text-nowrap"; // Default classes
        var cName = c.therapist || c.region ||'';
        if (cName.match(/Total/))
           classStr += ' bg-dark';
        else if (cName.match(/Subtotal/))
           classStr += ' text-dark bg-primary';
        return classStr;
      },
    },
  }
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
  table.b-table[aria-busy='true'] {
    opacity: 0.4;
  }
  .formatlastrow tr:last-child {
    border-top: double;
  }
</style>
